import { Aggregator } from '@liberty-financial/agp-shared';
import * as _ from 'lodash';

import { aggregator } from '@env/aggregator/aggregator';
import {
  OptionsPropertyDefinition,
  StringPropertyDefinition
} from '@shared/models/schema-property-definition';

import { LeadReferrer } from './lead-referrer';
import { LeadReferrerArrangement } from './lead-referrer/referrer-arrangement';

export namespace Lead {
  export enum Status {
    Open = 'Open',
    Closed = 'Closed'
  }

  export enum TerminateReason {
    DuplicateLead = 'Duplicate lead',
    FalseDetails = 'False details',
    NotContactable = 'Not contactable',
    Training = 'Training',
    GoneElsewhere = 'Gone elsewhere',
    Other = 'Other'
  }

  interface RegionPropertyDefinition {
    region: OptionsPropertyDefinition;
  }

  interface PostcodePropertyDefinition {
    postcode: StringPropertyDefinition;
  }

  export interface SchemaPropertyDefinition {
    dayToCall: OptionsPropertyDefinition;
    email: StringPropertyDefinition;
    existingContactId: StringPropertyDefinition;
    firstName: StringPropertyDefinition;
    lastName: StringPropertyDefinition;
    marketing: {
      analyticsTrackingReference: StringPropertyDefinition;
      campaignId: StringPropertyDefinition;
      methodType: StringPropertyDefinition;
    };
    phoneNumber: StringPropertyDefinition;
    area: RegionPropertyDefinition | PostcodePropertyDefinition;
    preferredContactMethod: OptionsPropertyDefinition;
    referrer: {
      lendingPartner: LeadReferrerArrangement.SchemaPropertyDefinition;
      referrerId: StringPropertyDefinition;
    };
    source: OptionsPropertyDefinition;
    subject: OptionsPropertyDefinition;
    timeToCall: OptionsPropertyDefinition;
  }

  interface Postcode {
    postcode: string;
  }

  interface Region {
    region: string;
  }

  export interface BaseSchemaContract {
    dayToCall: string;
    email: string;
    existingContactId: string | null;
    firstName: string;
    lastName: string;
    marketing: {
      analyticsTrackingReference: string | null;
      campaignId: string | null;
      methodType: string | null;
    };
    adviserCampaignId: string | null;
    phoneNumber: string;
    preferredContactMethod: string;
    referrer: LeadReferrer.SchemaContract;
    source: string;
    subject: string | null;
    timeToCall: string;
    status: string;
  }

  interface BaseModel {
    dayToCall: string;
    email: string;
    existingContactId: string | null;
    firstName: string;
    lastName: string;
    marketing: {
      analyticsTrackingReference: string | null;
      campaignId: string | null;
      methodType: string | null;
    };
    adviserCampaignId: string | null;
    phoneNumber: string;
    preferredContactMethod: string;
    referrer: LeadReferrer.Model;
    source: string;
    subject: string | null;
    timeToCall: string;
    status: string;
  }

  export type Model = BaseModel & (Postcode | Region);

  export type SchemaContract = BaseSchemaContract & (Postcode | Region);

  export function toModel(lead: SchemaContract): Model {
    return {
      ...lead,
      referrer: LeadReferrer.toModel(lead.referrer)
    };
  }

  export function toSchemaContract(
    lead: Partial<Model>
  ): Partial<SchemaContract> {
    return {
      ...lead,
      referrer: lead.referrer
        ? LeadReferrer.toSchemaContract(lead.referrer)
        : null,
      postcode:
        aggregator.name === Aggregator.LNS || aggregator.name === Aggregator.NMB
          ? (lead as Postcode).postcode
          : undefined,
      region:
        aggregator.name === Aggregator.MPM ? (lead as Region).region : undefined
    };
  }
}
